import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class SensorService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'sensores');
  }

  /**
   * GET /api/sensores/{id}/estacao-relacionada
   * Verifica se o sensor tem estação vinculada. Retorna existe e estacao (id, nome).
   */
  getEstacaoRelacionada(id: number): Observable<{ existe: boolean; estacao: { id: number; nome: string } | null }> {
    return this.http.get<any>(`${this.url_base}/${this.prefixo}/${id}/estacao-relacionada`);
  }
}
